<template>
  <b-modal
    :value="visible"
    title="Importuj tłumaczenia"
    @ok="handleImport"
    @hidden="handleHidden"
    @input="$emit('input', $event)">
    <b-form @submit.prevent="handleImport">
      <b-form-group label="Wybierz plik" label-for="import-file">
        <b-form-file
          id="import-file"
          :value="importFile"
          accept=".json,.csv"
          placeholder="Wybierz plik z tłumaczeniami..."
          @input="$emit('update:import-file', $event)" />
        <small class="text-muted">Obsługiwane formaty: JSON, CSV</small>
      </b-form-group>

      <b-form-group>
        <b-form-checkbox :checked="importOptions.overwrite" @change="updateImportOption('overwrite', $event)">
          Nadpisz istniejące tłumaczenia
        </b-form-checkbox>
        <b-form-checkbox :checked="importOptions.backup" @change="updateImportOption('backup', $event)">
          Utwórz kopię zapasową przed importem
        </b-form-checkbox>
      </b-form-group>

      <b-alert v-if="!importFile" variant="info" show class="mb-0">
        <feather-icon icon="InfoIcon" size="16" class="mr-1" />
        Wybierz plik z tłumaczeniami, aby kontynuować import.
      </b-alert>

      <b-alert v-if="importFile && !isValidFileType" variant="warning" show class="mb-0">
        <feather-icon icon="AlertTriangleIcon" size="16" class="mr-1" />
        Nieprawidłowy format pliku. Obsługiwane formaty: JSON, CSV.
      </b-alert>
    </b-form>

    <template #modal-footer="{ ok, cancel }">
      <b-button variant="secondary" @click="cancel"> Anuluj </b-button>
      <b-button variant="primary" :disabled="!importFile || !isValidFileType" @click="ok">
        <feather-icon icon="UploadIcon" size="16" class="mr-1" />
        Importuj
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { computed } from '@vue/composition-api';

export default {
  name: 'ImportModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    importFile: {
      type: File,
      default: null,
    },
    importOptions: {
      type: Object,
      default: () => ({
        overwrite: false,
        backup: true,
      }),
    },
  },
  emits: ['input', 'import', 'reset', 'update:import-file', 'update:import-options'],
  setup(props, { emit }) {
    const isValidFileType = computed(() => {
      if (!props.importFile) return true;
      const validTypes = ['.json', '.csv'];
      return validTypes.some((type) => props.importFile.name.toLowerCase().endsWith(type));
    });

    const handleImport = () => {
      if (!props.importFile || !isValidFileType.value) return;
      emit('import');
    };

    const handleHidden = () => {
      emit('reset');
    };

    const updateImportOption = (key, value) => {
      const newOptions = { ...props.importOptions, [key]: value };
      emit('update:import-options', newOptions);
    };

    return {
      isValidFileType,
      handleImport,
      handleHidden,
      updateImportOption,
    };
  },
};
</script>